import { render, staticRenderFns } from "./NcrObsPdfDocument.vue?vue&type=template&id=730f8280&"
import script from "./NcrObsPdfDocument.vue?vue&type=script&lang=js&"
export * from "./NcrObsPdfDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports